import { render, staticRenderFns } from "./houses_list.vue?vue&type=template&id=13e12e54&scoped=true&"
import script from "./houses_list.vue?vue&type=script&lang=js&"
export * from "./houses_list.vue?vue&type=script&lang=js&"
import style0 from "./houses_list.vue?vue&type=style&index=0&id=13e12e54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e12e54",
  null
  
)

export default component.exports